import { render, staticRenderFns } from "./Convention.vue?vue&type=template&id=57377560&scoped=true"
import script from "./Convention.vue?vue&type=script&lang=js"
export * from "./Convention.vue?vue&type=script&lang=js"
import style0 from "./Convention.vue?vue&type=style&index=0&id=57377560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57377560",
  null
  
)

export default component.exports